import Title from 'components/Title';
import React from 'react';
import styled from 'styled-components';
import { HiChevronDown } from 'react-icons/hi';
import Req from 'utils/Request';
import { getAuthContext } from 'contexts/auth';
import { NotificationManager } from 'react-notifications';
import { AiOutlinePlus } from 'react-icons/ai';
import Button from 'components/Button';
import Div from 'components/Div';
import { popupFormStyle } from 'utils/sharedStyles';
import Form from 'components/Form';
import Dialog from 'components/Dialog';
import { formSuggestionCategory } from 'utils/formModels';

const SuggestionCategory = ({ onChange, addressOnly = false }) => {
    const [manager, setManager] = React.useState(null);
    const [categories, setCategories] = React.useState([]);
    const [indices, setIndices] = React.useState('');
    const [categoryObject, setCategoryObject] = React.useState(null);
    const [editCategory, setEditCategory] = React.useState(null);
    const [deleteCategory, setDeleteCategory] = React.useState(null);
    const [showCreate, setShowCreate] = React.useState(false);
    const [createCategoryInstance, setCreateCategoryInstance] = React.useState({});
    const { roles } = React.useContext(getAuthContext);
    const formRef = React.useRef();

    React.useEffect(() => {
        fetchCategory();
    }, []);
    React.useEffect(() => {
        const filtered = roles.filter((x) => x === 'INFO');
        if (filtered[0]) setManager(filtered[0]);
    }, [roles]);
    const fetchCategory = async () => {
        const result = await Req({ url: '/suggestion/category/list', hideSuccess: true });
        const resultRows = result.data.data.suggestionCategory.rows;
        const addressOnlyRows = resultRows.filter(
            (x) => x.name.includes('Хаяг нэмэх хүсэлт') || x.name.includes('Хүргэлтийн бүс нэмэх') || x.name.includes('Хаяг шинэчлэх хүсэлт') || x.name.includes('Салбарын байршилтай')
        );
        let otherRemainedRows = resultRows.filter((x) => !x.name.includes('Хаяг нэмэх хүсэлт'));
        otherRemainedRows = otherRemainedRows.filter((x) => !x.name.includes('Хүргэлтийн бүс нэмэх'));
        otherRemainedRows = otherRemainedRows.filter((x) => !x.name.includes('Салбарын байршилтай'));
        otherRemainedRows = otherRemainedRows.filter((x) => !x.name.includes('Хаяг шинэчлэх хүсэлт'));
        setCategories(addressOnly ? addressOnlyRows : otherRemainedRows);
    };
    React.useEffect(() => {
        resolveIndices();
    }, [indices]);
    const resolveIndices = () => {
        if (!indices) return setCategoryObject(null);
        const indexes = indices.split('.');
        if (indexes.length === 2)
            setCategoryObject({
                category: categories[indexes[0]].name,
                childCategory: categories[indexes[1]].name,
            });
        else if (indexes.length === 1)
            setCategoryObject({
                category: categories[indexes[0]].name,
            });
    };
    const handleCreate = async (e) => {
        e?.preventDefault();
        const body = {
            ...createCategoryInstance,
            isAddress: addressOnly ? true : false,
        };
        await Req({ url: '/suggestion/category/create', body });
        fetchCategory();
        setShowCreate(false);
    };
    const handleUpdateSave = async (e) => {
        e?.preventDefault();
        if (!editCategory.name || editCategory.name === '') return NotificationManager.warning('Төрөлөө оруулна уу', '', 10000);
        // if (!editCategory.level || editCategory.level === '') return NotificationManager.warning('Түвшин оруулна уу.', '', 10000);
        const body = { id: editCategory.id, name: editCategory.name, level: editCategory.level };
        await Req({ url: '/suggestion/category/update', body });
        fetchCategory();
        setEditCategory(null);
    };
    const handleDelete = async () => {
        if (!deleteCategory) return NotificationManager.warning('Устгах төрөлөө сонгоно уу!', '', 10000);
        const body = {
            id: deleteCategory.id,
        };
        const result = await Req({ url: '/suggestion/category/delete', body });
        if (result.code === 200 && result.success) {
            return NotificationManager.success('Амжилттай хадгаллаа!', '', 10000);
        }
        setDeleteCategory(null);
        fetchCategory();
    };

    React.useEffect(() => {
        onChange(categoryObject);
    }, [categoryObject]);
    return (
        <Container>
            <Title size={12} btmLine>
                <div className="top">
                    <span>Төрлүүд</span>
                    {manager && (
                        <Button onClick={() => setShowCreate(true)} bg="green" color="white">
                            <AiOutlinePlus />
                            Төрөл үүсгэх
                        </Button>
                    )}
                </div>
            </Title>
            <div className="tree_wrap">
                {categories.map((cat, catIndex) => (
                    <div className="instance_wrap" key={cat.id}>
                        <span data-children={cat.children?.length ? true : false} open={indices === '' + catIndex + ''} onClick={() => setIndices('' + cat.children ? '' : catIndex + '')}>
                            {cat.children?.length ? <HiChevronDown /> : ''}
                            {cat.name}
                        </span>
                        {manager && (
                            <Div c="btn_wrap">
                                <Button bg="green" color="white" onClick={() => setEditCategory(cat)}>
                                    Засах
                                </Button>
                                <Button
                                    bg="color"
                                    onClick={() => {
                                        setDeleteCategory({
                                            id: cat.id,
                                        });
                                    }}
                                >
                                    Устгах
                                </Button>
                            </Div>
                        )}
                        {cat?.children.map((child, childIndex) => (
                            <div className="instance_wrap child" key={child.id}>
                                <span open={indices === catIndex + '.' + childIndex} onClick={() => setIndices(catIndex + '.' + childIndex)}>
                                    {child.name}
                                </span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
            {manager && showCreate && (
                <Dialog
                    onClose={() => setShowCreate(false)}
                    title="Төрөл үүсгэх"
                    submit={
                        <Button onClick={() => formRef.current.querySelector('.submit').click()} bg="blue" type="submit">
                            Хадгалах
                        </Button>
                    }
                    // width="500px"
                >
                    <Div c="create_category_wrap">
                        <Form
                            forwardRef={formRef}
                            model={formSuggestionCategory}
                            instance={createCategoryInstance}
                            styles={popupFormStyle}
                            listenChange={setCreateCategoryInstance}
                            onSubmit={handleCreate}
                        />
                    </Div>
                </Dialog>
            )}
            {manager && editCategory && (
                <Dialog
                    onClose={() => setEditCategory(null)}
                    title="Гомдолын төрөл засах"
                    submit={
                        <Button onClick={() => formRef.current.querySelector('.submit').click()} bg="blue" type="submit">
                            Хадгалах
                        </Button>
                    }
                    // width="500px"
                >
                    <Form forwardRef={formRef} model={formSuggestionCategory} instance={editCategory} styles={popupFormStyle} listenChange={setEditCategory} onSubmit={handleUpdateSave} />
                </Dialog>
            )}
            {manager && deleteCategory && (
                <Dialog
                    onClose={() => setDeleteCategory(null)}
                    title={'Энэ төрөлийг устгахдаа итгэлтэй байна уу?'}
                    submit={
                        <Button onClick={() => handleDelete()} bg="green">
                            Тийм
                        </Button>
                    }
                >
                    <Container>
                        <Form instance={deleteCategory} listenChange={setDeleteCategory} onSubmit={handleDelete} forwardRef={formRef} model={{}} />
                    </Container>
                </Dialog>
            )}
        </Container>
    );
};

export default SuggestionCategory;

const Container = styled.div`
    margin-right: 30px;
    padding-right: 30px;
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    max-height: 70vh;
    overflow: hidden;
    overflow-y: scroll;
    .top {
        display: flex;
        justify-content: space-between;
    }
    .tree_wrap {
        min-width: 285px;
        .instance_wrap {
            span {
                padding: 10px 15px;
                display: flex;
                align-items: center;
                cursor: pointer;
                margin: 5px 0px;
                svg {
                    margin-right: 4px;
                }
                &[open] {
                    background: ${({ theme }) => theme.green};
                    color: white;
                }
                &[data-children='true'] {
                    opacity: 0.6;
                    text-decoration: underline;
                    cursor: default;
                    margin-left: -15px;
                }
            }
        }
        .instance_wrap.child {
            span {
                margin-left: 15px;
            }
        }
    }
    .btn_wrap {
        margin-top: 15px;
        display: flex;
        gap: 10px;
        justify-content: flex-end;
    }
`;
